var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item Icon",
    clipPath: "url(#clip0_4449_180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.90909C0 1.30255 1.30255 0 2.90909 0L13.0909 0C14.6975 0 16 1.30255 16 2.90909V13.0909C16 14.6975 14.6975 16 13.0909 16H2.90909C1.30255 16 0 14.6975 0 13.0909L0 2.90909ZM2.90909 1.45455C2.10513 1.45455 1.45455 2.10513 1.45455 2.90909V13.0909C1.45455 13.8949 2.10513 14.5455 2.90909 14.5455H13.0909C13.8949 14.5455 14.5455 13.8949 14.5455 13.0909V2.90909C14.5455 2.10513 13.8949 1.45455 13.0909 1.45455H2.90909ZM3.84943 4.57673C4.13352 4.29264 4.59376 4.29264 4.87783 4.57673L7.78692 7.48582C8.07101 7.76991 8.07101 8.23015 7.78692 8.51422L4.87783 11.4233C4.59374 11.7074 4.1335 11.7074 3.84943 11.4233C3.56536 11.1392 3.56534 10.679 3.84943 10.3949L6.24431 8.00004L3.84943 5.60517C3.56534 5.32107 3.56534 4.8608 3.84943 4.57673ZM8 10.1818C7.59801 10.1818 7.27273 10.5071 7.27273 10.9091C7.27273 11.3111 7.598 11.6364 8 11.6364H11.6364C12.0384 11.6364 12.3636 11.3111 12.3636 10.9091C12.3636 10.5071 12.0384 10.1818 11.6364 10.1818H8Z",
    fill: "#767A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4449_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionIcon4);
export default __webpack_public_path__ + "static/media/solution_icon_4.22963c4d1fbf7c03a0a6b6744e319615.svg";
export { ForwardRef as ReactComponent };